import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

export interface ClientData {
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  clientPhone: string;
  personReceivingCare: string;
  careRecipientFirstName: string;
  careRecipientLastName: string;
  context: string;
}

export interface LeadData {
  whoWillPay: string;
  discountCode: string;
  licenceCode?: string;
  consentCommunications: boolean;
  consentShareInfo: boolean;
}

export interface ClientReferralState {
  clientData: ClientData | null;
  leadData: LeadData | null;
}

const initialState: ClientReferralState = {
  clientData: null,
  leadData: null,
};

export const clientReferralSlice = createSlice({
  name: 'clientReferral',
  initialState,
  reducers: {
    setClientData: (state, action: PayloadAction<ClientData>) => {
      state.clientData = action.payload;
    },
    setLeadData: (state, action: PayloadAction<LeadData>) => {
      state.leadData = action.payload;
    },
    resetClientReferral: () => initialState,
  },
});

export const { setClientData, setLeadData, resetClientReferral } =
  clientReferralSlice.actions;

export const getClientData = (state: RootState) =>
  state.clientReferral.clientData;
export const getLeadData = (state: RootState) => state.clientReferral.leadData;

export default clientReferralSlice.reducer;
